import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enNav from './locales/en/nav.json';
import enLayout from './locales/en/layout.json';
import enAuth from './locales/en/auth.json';
import enDashboard from './locales/en/dashboard.json';
import enAssets from './locales/en/assets.json';
import enMaintenance from './locales/en/maintenance.json';
import enBookings from './locales/en/bookings.json';
import enOrders from './locales/en/orders.json';
import enServices from './locales/en/services.json';
import enSettings from './locales/en/settings.json';
import enFamily from './locales/en/family.json';
import enOnboarding from './locales/en/onboarding.json';
import enDiscovery from './locales/en/discovery.json';
import enProfile from './locales/en/profile.json';
import enAiDrawer from './locales/en/aiDrawer.json';
import enWarranty from './locales/en/warranty.json';
import enAddAsset from './locales/en/addAsset.json';
import enLegal from './locales/en/legal.json';
import enBrandsmart from './locales/en/brandsmart.json';
import enPayment from './locales/en/payment.json';
import enUpgrade from './locales/en/upgrade.json';
import enAiFix from './locales/en/aiFix.json';
import enHome from './locales/en/home.json';
import enCommon from './locales/en/common.json';

import esNav from './locales/es/nav.json';
import esLayout from './locales/es/layout.json';
import esAuth from './locales/es/auth.json';
import esDashboard from './locales/es/dashboard.json';
import esAssets from './locales/es/assets.json';
import esMaintenance from './locales/es/maintenance.json';
import esBookings from './locales/es/bookings.json';
import esOrders from './locales/es/orders.json';
import esServices from './locales/es/services.json';
import esSettings from './locales/es/settings.json';
import esFamily from './locales/es/family.json';
import esOnboarding from './locales/es/onboarding.json';
import esDiscovery from './locales/es/discovery.json';
import esProfile from './locales/es/profile.json';
import esAiDrawer from './locales/es/aiDrawer.json';
import esWarranty from './locales/es/warranty.json';
import esAddAsset from './locales/es/addAsset.json';
import esLegal from './locales/es/legal.json';
import esBrandsmart from './locales/es/brandsmart.json';
import esPayment from './locales/es/payment.json';
import esUpgrade from './locales/es/upgrade.json';
import esAiFix from './locales/es/aiFix.json';
import esHome from './locales/es/home.json';
import esCommon from './locales/es/common.json';

import zhNav from './locales/zh/nav.json';
import zhLayout from './locales/zh/layout.json';
import zhAuth from './locales/zh/auth.json';
import zhDashboard from './locales/zh/dashboard.json';
import zhAssets from './locales/zh/assets.json';
import zhMaintenance from './locales/zh/maintenance.json';
import zhBookings from './locales/zh/bookings.json';
import zhOrders from './locales/zh/orders.json';
import zhServices from './locales/zh/services.json';
import zhSettings from './locales/zh/settings.json';
import zhFamily from './locales/zh/family.json';
import zhOnboarding from './locales/zh/onboarding.json';
import zhDiscovery from './locales/zh/discovery.json';
import zhProfile from './locales/zh/profile.json';
import zhAiDrawer from './locales/zh/aiDrawer.json';
import zhWarranty from './locales/zh/warranty.json';
import zhAddAsset from './locales/zh/addAsset.json';
import zhLegal from './locales/zh/legal.json';
import zhBrandsmart from './locales/zh/brandsmart.json';
import zhPayment from './locales/zh/payment.json';
import zhUpgrade from './locales/zh/upgrade.json';
import zhAiFix from './locales/zh/aiFix.json';
import zhHome from './locales/zh/home.json';
import zhCommon from './locales/zh/common.json';

import hiNav from './locales/hi/nav.json';
import hiLayout from './locales/hi/layout.json';
import hiAuth from './locales/hi/auth.json';
import hiDashboard from './locales/hi/dashboard.json';
import hiAssets from './locales/hi/assets.json';
import hiMaintenance from './locales/hi/maintenance.json';
import hiBookings from './locales/hi/bookings.json';
import hiOrders from './locales/hi/orders.json';
import hiServices from './locales/hi/services.json';
import hiSettings from './locales/hi/settings.json';
import hiFamily from './locales/hi/family.json';
import hiOnboarding from './locales/hi/onboarding.json';
import hiDiscovery from './locales/hi/discovery.json';
import hiProfile from './locales/hi/profile.json';
import hiAiDrawer from './locales/hi/aiDrawer.json';
import hiWarranty from './locales/hi/warranty.json';
import hiAddAsset from './locales/hi/addAsset.json';
import hiLegal from './locales/hi/legal.json';
import hiBrandsmart from './locales/hi/brandsmart.json';
import hiPayment from './locales/hi/payment.json';
import hiUpgrade from './locales/hi/upgrade.json';
import hiAiFix from './locales/hi/aiFix.json';
import hiHome from './locales/hi/home.json';
import hiCommon from './locales/hi/common.json';

import frNav from './locales/fr/nav.json';
import frLayout from './locales/fr/layout.json';
import frAuth from './locales/fr/auth.json';
import frDashboard from './locales/fr/dashboard.json';
import frAssets from './locales/fr/assets.json';
import frMaintenance from './locales/fr/maintenance.json';
import frBookings from './locales/fr/bookings.json';
import frOrders from './locales/fr/orders.json';
import frServices from './locales/fr/services.json';
import frSettings from './locales/fr/settings.json';
import frFamily from './locales/fr/family.json';
import frOnboarding from './locales/fr/onboarding.json';
import frDiscovery from './locales/fr/discovery.json';
import frProfile from './locales/fr/profile.json';
import frAiDrawer from './locales/fr/aiDrawer.json';
import frWarranty from './locales/fr/warranty.json';
import frAddAsset from './locales/fr/addAsset.json';
import frLegal from './locales/fr/legal.json';
import frBrandsmart from './locales/fr/brandsmart.json';
import frPayment from './locales/fr/payment.json';
import frUpgrade from './locales/fr/upgrade.json';
import frAiFix from './locales/fr/aiFix.json';
import frHome from './locales/fr/home.json';
import frCommon from './locales/fr/common.json';

import ptNav from './locales/pt/nav.json';
import ptLayout from './locales/pt/layout.json';
import ptAuth from './locales/pt/auth.json';
import ptDashboard from './locales/pt/dashboard.json';
import ptAssets from './locales/pt/assets.json';
import ptMaintenance from './locales/pt/maintenance.json';
import ptBookings from './locales/pt/bookings.json';
import ptOrders from './locales/pt/orders.json';
import ptServices from './locales/pt/services.json';
import ptSettings from './locales/pt/settings.json';
import ptFamily from './locales/pt/family.json';
import ptOnboarding from './locales/pt/onboarding.json';
import ptDiscovery from './locales/pt/discovery.json';
import ptProfile from './locales/pt/profile.json';
import ptAiDrawer from './locales/pt/aiDrawer.json';
import ptWarranty from './locales/pt/warranty.json';
import ptAddAsset from './locales/pt/addAsset.json';
import ptLegal from './locales/pt/legal.json';
import ptBrandsmart from './locales/pt/brandsmart.json';
import ptPayment from './locales/pt/payment.json';
import ptUpgrade from './locales/pt/upgrade.json';
import ptAiFix from './locales/pt/aiFix.json';
import ptHome from './locales/pt/home.json';
import ptCommon from './locales/pt/common.json';

import arNav from './locales/ar/nav.json';
import arLayout from './locales/ar/layout.json';
import arAuth from './locales/ar/auth.json';
import arDashboard from './locales/ar/dashboard.json';
import arAssets from './locales/ar/assets.json';
import arMaintenance from './locales/ar/maintenance.json';
import arBookings from './locales/ar/bookings.json';
import arOrders from './locales/ar/orders.json';
import arServices from './locales/ar/services.json';
import arSettings from './locales/ar/settings.json';
import arFamily from './locales/ar/family.json';
import arOnboarding from './locales/ar/onboarding.json';
import arDiscovery from './locales/ar/discovery.json';
import arProfile from './locales/ar/profile.json';
import arAiDrawer from './locales/ar/aiDrawer.json';
import arWarranty from './locales/ar/warranty.json';
import arAddAsset from './locales/ar/addAsset.json';
import arLegal from './locales/ar/legal.json';
import arBrandsmart from './locales/ar/brandsmart.json';
import arPayment from './locales/ar/payment.json';
import arUpgrade from './locales/ar/upgrade.json';
import arAiFix from './locales/ar/aiFix.json';
import arHome from './locales/ar/home.json';
import arCommon from './locales/ar/common.json';

import koNav from './locales/ko/nav.json';
import koLayout from './locales/ko/layout.json';
import koAuth from './locales/ko/auth.json';
import koDashboard from './locales/ko/dashboard.json';
import koAssets from './locales/ko/assets.json';
import koMaintenance from './locales/ko/maintenance.json';
import koBookings from './locales/ko/bookings.json';
import koOrders from './locales/ko/orders.json';
import koServices from './locales/ko/services.json';
import koSettings from './locales/ko/settings.json';
import koFamily from './locales/ko/family.json';
import koOnboarding from './locales/ko/onboarding.json';
import koDiscovery from './locales/ko/discovery.json';
import koProfile from './locales/ko/profile.json';
import koAiDrawer from './locales/ko/aiDrawer.json';
import koWarranty from './locales/ko/warranty.json';
import koAddAsset from './locales/ko/addAsset.json';
import koLegal from './locales/ko/legal.json';
import koBrandsmart from './locales/ko/brandsmart.json';
import koPayment from './locales/ko/payment.json';
import koUpgrade from './locales/ko/upgrade.json';
import koAiFix from './locales/ko/aiFix.json';
import koHome from './locales/ko/home.json';
import koCommon from './locales/ko/common.json';

import viNav from './locales/vi/nav.json';
import viLayout from './locales/vi/layout.json';
import viAuth from './locales/vi/auth.json';
import viDashboard from './locales/vi/dashboard.json';
import viAssets from './locales/vi/assets.json';
import viMaintenance from './locales/vi/maintenance.json';
import viBookings from './locales/vi/bookings.json';
import viOrders from './locales/vi/orders.json';
import viServices from './locales/vi/services.json';
import viSettings from './locales/vi/settings.json';
import viFamily from './locales/vi/family.json';
import viOnboarding from './locales/vi/onboarding.json';
import viDiscovery from './locales/vi/discovery.json';
import viProfile from './locales/vi/profile.json';
import viAiDrawer from './locales/vi/aiDrawer.json';
import viWarranty from './locales/vi/warranty.json';
import viAddAsset from './locales/vi/addAsset.json';
import viLegal from './locales/vi/legal.json';
import viBrandsmart from './locales/vi/brandsmart.json';
import viPayment from './locales/vi/payment.json';
import viUpgrade from './locales/vi/upgrade.json';
import viAiFix from './locales/vi/aiFix.json';
import viHome from './locales/vi/home.json';
import viCommon from './locales/vi/common.json';

import tlNav from './locales/tl/nav.json';
import tlLayout from './locales/tl/layout.json';
import tlAuth from './locales/tl/auth.json';
import tlDashboard from './locales/tl/dashboard.json';
import tlAssets from './locales/tl/assets.json';
import tlMaintenance from './locales/tl/maintenance.json';
import tlBookings from './locales/tl/bookings.json';
import tlOrders from './locales/tl/orders.json';
import tlServices from './locales/tl/services.json';
import tlSettings from './locales/tl/settings.json';
import tlFamily from './locales/tl/family.json';
import tlOnboarding from './locales/tl/onboarding.json';
import tlDiscovery from './locales/tl/discovery.json';
import tlProfile from './locales/tl/profile.json';
import tlAiDrawer from './locales/tl/aiDrawer.json';
import tlWarranty from './locales/tl/warranty.json';
import tlAddAsset from './locales/tl/addAsset.json';
import tlLegal from './locales/tl/legal.json';
import tlBrandsmart from './locales/tl/brandsmart.json';
import tlPayment from './locales/tl/payment.json';
import tlUpgrade from './locales/tl/upgrade.json';
import tlAiFix from './locales/tl/aiFix.json';
import tlHome from './locales/tl/home.json';
import tlCommon from './locales/tl/common.json';

import deNav from './locales/de/nav.json';
import deLayout from './locales/de/layout.json';
import deAuth from './locales/de/auth.json';
import deDashboard from './locales/de/dashboard.json';
import deAssets from './locales/de/assets.json';
import deMaintenance from './locales/de/maintenance.json';
import deBookings from './locales/de/bookings.json';
import deOrders from './locales/de/orders.json';
import deServices from './locales/de/services.json';
import deSettings from './locales/de/settings.json';
import deFamily from './locales/de/family.json';
import deOnboarding from './locales/de/onboarding.json';
import deDiscovery from './locales/de/discovery.json';
import deProfile from './locales/de/profile.json';
import deAiDrawer from './locales/de/aiDrawer.json';
import deWarranty from './locales/de/warranty.json';
import deAddAsset from './locales/de/addAsset.json';
import deLegal from './locales/de/legal.json';
import deBrandsmart from './locales/de/brandsmart.json';
import dePayment from './locales/de/payment.json';
import deUpgrade from './locales/de/upgrade.json';
import deAiFix from './locales/de/aiFix.json';
import deHome from './locales/de/home.json';
import deCommon from './locales/de/common.json';

const SUPPORTED_LANGUAGES = new Set(['en', 'es', 'zh', 'hi', 'fr', 'pt', 'ar', 'ko', 'vi', 'tl', 'de']);

function getInitialLanguage(): string {
  if (typeof window === 'undefined') return 'en';

  try {
    const raw = window.localStorage.getItem('language-storage');
    if (!raw) return 'en';

    const parsed = JSON.parse(raw) as { state?: { language?: string } };
    const persistedLang = parsed?.state?.language;
    if (persistedLang && SUPPORTED_LANGUAGES.has(persistedLang)) {
      return persistedLang;
    }
  } catch {
    // Ignore malformed persisted state and fall back to English.
  }

  return 'en';
}

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        nav: enNav, layout: enLayout, auth: enAuth, dashboard: enDashboard,
        assets: enAssets, maintenance: enMaintenance, bookings: enBookings,
        orders: enOrders, services: enServices, settings: enSettings,
        family: enFamily, onboarding: enOnboarding, discovery: enDiscovery,
        profile: enProfile, aiDrawer: enAiDrawer, addAsset: enAddAsset,
        warranty: enWarranty, legal: enLegal, brandsmart: enBrandsmart,
        payment: enPayment, upgrade: enUpgrade, aiFix: enAiFix,
        home: enHome, common: enCommon,
      },
      es: {
        nav: esNav, layout: esLayout, auth: esAuth, dashboard: esDashboard,
        assets: esAssets, maintenance: esMaintenance, bookings: esBookings,
        orders: esOrders, services: esServices, settings: esSettings,
        family: esFamily, onboarding: esOnboarding, discovery: esDiscovery,
        profile: esProfile, aiDrawer: esAiDrawer, addAsset: esAddAsset,
        warranty: esWarranty, legal: esLegal, brandsmart: esBrandsmart,
        payment: esPayment, upgrade: esUpgrade, aiFix: esAiFix,
        home: esHome, common: esCommon,
      },
      zh: {
        nav: zhNav, layout: zhLayout, auth: zhAuth, dashboard: zhDashboard,
        assets: zhAssets, maintenance: zhMaintenance, bookings: zhBookings,
        orders: zhOrders, services: zhServices, settings: zhSettings,
        family: zhFamily, onboarding: zhOnboarding, discovery: zhDiscovery,
        profile: zhProfile, aiDrawer: zhAiDrawer, addAsset: zhAddAsset,
        warranty: zhWarranty, legal: zhLegal, brandsmart: zhBrandsmart,
        payment: zhPayment, upgrade: zhUpgrade, aiFix: zhAiFix,
        home: zhHome, common: zhCommon,
      },
      hi: {
        nav: hiNav, layout: hiLayout, auth: hiAuth, dashboard: hiDashboard,
        assets: hiAssets, maintenance: hiMaintenance, bookings: hiBookings,
        orders: hiOrders, services: hiServices, settings: hiSettings,
        family: hiFamily, onboarding: hiOnboarding, discovery: hiDiscovery,
        profile: hiProfile, aiDrawer: hiAiDrawer, addAsset: hiAddAsset,
        warranty: hiWarranty, legal: hiLegal, brandsmart: hiBrandsmart,
        payment: hiPayment, upgrade: hiUpgrade, aiFix: hiAiFix,
        home: hiHome, common: hiCommon,
      },
      fr: {
        nav: frNav, layout: frLayout, auth: frAuth, dashboard: frDashboard,
        assets: frAssets, maintenance: frMaintenance, bookings: frBookings,
        orders: frOrders, services: frServices, settings: frSettings,
        family: frFamily, onboarding: frOnboarding, discovery: frDiscovery,
        profile: frProfile, aiDrawer: frAiDrawer, addAsset: frAddAsset,
        warranty: frWarranty, legal: frLegal, brandsmart: frBrandsmart,
        payment: frPayment, upgrade: frUpgrade, aiFix: frAiFix,
        home: frHome, common: frCommon,
      },
      pt: {
        nav: ptNav, layout: ptLayout, auth: ptAuth, dashboard: ptDashboard,
        assets: ptAssets, maintenance: ptMaintenance, bookings: ptBookings,
        orders: ptOrders, services: ptServices, settings: ptSettings,
        family: ptFamily, onboarding: ptOnboarding, discovery: ptDiscovery,
        profile: ptProfile, aiDrawer: ptAiDrawer, addAsset: ptAddAsset,
        warranty: ptWarranty, legal: ptLegal, brandsmart: ptBrandsmart,
        payment: ptPayment, upgrade: ptUpgrade, aiFix: ptAiFix,
        home: ptHome, common: ptCommon,
      },
      ar: {
        nav: arNav, layout: arLayout, auth: arAuth, dashboard: arDashboard,
        assets: arAssets, maintenance: arMaintenance, bookings: arBookings,
        orders: arOrders, services: arServices, settings: arSettings,
        family: arFamily, onboarding: arOnboarding, discovery: arDiscovery,
        profile: arProfile, aiDrawer: arAiDrawer, addAsset: arAddAsset,
        warranty: arWarranty, legal: arLegal, brandsmart: arBrandsmart,
        payment: arPayment, upgrade: arUpgrade, aiFix: arAiFix,
        home: arHome, common: arCommon,
      },
      ko: {
        nav: koNav, layout: koLayout, auth: koAuth, dashboard: koDashboard,
        assets: koAssets, maintenance: koMaintenance, bookings: koBookings,
        orders: koOrders, services: koServices, settings: koSettings,
        family: koFamily, onboarding: koOnboarding, discovery: koDiscovery,
        profile: koProfile, aiDrawer: koAiDrawer, addAsset: koAddAsset,
        warranty: koWarranty, legal: koLegal, brandsmart: koBrandsmart,
        payment: koPayment, upgrade: koUpgrade, aiFix: koAiFix,
        home: koHome, common: koCommon,
      },
      vi: {
        nav: viNav, layout: viLayout, auth: viAuth, dashboard: viDashboard,
        assets: viAssets, maintenance: viMaintenance, bookings: viBookings,
        orders: viOrders, services: viServices, settings: viSettings,
        family: viFamily, onboarding: viOnboarding, discovery: viDiscovery,
        profile: viProfile, aiDrawer: viAiDrawer, addAsset: viAddAsset,
        warranty: viWarranty, legal: viLegal, brandsmart: viBrandsmart,
        payment: viPayment, upgrade: viUpgrade, aiFix: viAiFix,
        home: viHome, common: viCommon,
      },
      tl: {
        nav: tlNav, layout: tlLayout, auth: tlAuth, dashboard: tlDashboard,
        assets: tlAssets, maintenance: tlMaintenance, bookings: tlBookings,
        orders: tlOrders, services: tlServices, settings: tlSettings,
        family: tlFamily, onboarding: tlOnboarding, discovery: tlDiscovery,
        profile: tlProfile, aiDrawer: tlAiDrawer, addAsset: tlAddAsset,
        warranty: tlWarranty, legal: tlLegal, brandsmart: tlBrandsmart,
        payment: tlPayment, upgrade: tlUpgrade, aiFix: tlAiFix,
        home: tlHome, common: tlCommon,
      },
      de: {
        nav: deNav, layout: deLayout, auth: deAuth, dashboard: deDashboard,
        assets: deAssets, maintenance: deMaintenance, bookings: deBookings,
        orders: deOrders, services: deServices, settings: deSettings,
        family: deFamily, onboarding: deOnboarding, discovery: deDiscovery,
        profile: deProfile, aiDrawer: deAiDrawer, addAsset: deAddAsset,
        warranty: deWarranty, legal: deLegal, brandsmart: deBrandsmart,
        payment: dePayment, upgrade: deUpgrade, aiFix: deAiFix,
        home: deHome, common: deCommon,
      },
    },
    lng: getInitialLanguage(),
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
  });

export default i18n;
